<template>
  <app-layout>
    <b-navbar toggleable="sm" class="my-3 pl-0">
      <b-navbar-toggle target="subnav"></b-navbar-toggle>
      <b-navbar-brand href="#">
        <h1 class="h3">{{ $t("documents-title") }}</h1>
      </b-navbar-brand>
      <b-collapse is-nav id="subnav" class="c-subnav">
        <b-navbar-nav v-b-scrollspy class="ml-auto">
          <b-nav-item @click="onScrollTo('welcome')">{{
            $t("documents-welcome-booklet")
          }}</b-nav-item>
          <!-- Update this line to use correct ID -->
          <b-nav-item @click="onScrollTo('invoices')">{{
            $t("documents-invoices")
          }}</b-nav-item>
          <b-nav-item @click="onScrollTo('projectService')">{{
            $t("project-service-title")
          }}</b-nav-item>
          <b-nav-item @click="onScrollTo('other')">{{
            $t("documents-others")
          }}</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="row">
      <div class="col-lg-6">
        <vita-livret-accueil></vita-livret-accueil>
      </div>
      <div class="col-lg-6">
        <vita-telegestion
          :sectionTitle="$t('documents-my-qr-code-title')"
        ></vita-telegestion>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-lg-6" id="projectService">
        <vita-project-service :sectionTitle="$t('project-service-title')" />
      </div>
    </div>
    <section
      class="mb-3"
      v-if="unpaidInvoiceSize > 0"
      :id="unpaidInvoiceSize > 0 ? 'invoices' : ''"
    >
      <section-title>
        {{ $t("unpaid-invoices-management-title") }}
      </section-title>
      <div class="row">
        <vita-mes-factures
          :limit="4"
          :filter="1"
          :isOnlyLoadFilter="true"
          @update:datasize="newDataSize => (unpaidInvoiceSize = newDataSize)"
        ></vita-mes-factures>
      </div>
    </section>

    <section
      class="mb-3"
      v-show="paidInvoiceSize > 0"
      :id="unpaidInvoiceSize > 0 ? '' : 'invoices'"
    >
      <section-title>
        {{ $t("paid-invoices-management-title") }}
      </section-title>
      <div class="row">
        <vita-mes-factures
          ref="invoices"
          :limit="4"
          :filter="2"
          :isOnlyLoadFilter="true"
          @update:datasize="newDataSize => (paidInvoiceSize = newDataSize)"
        ></vita-mes-factures>
      </div>
    </section>
    <!-- Pour le mois courant -->
    <!-- <vita-mes-factures :month="currentMonth" :invoicesFilterType="invoicesFilterType"></vita-mes-factures> -->

    <!-- <div class="col-lg-12">
     
      <p class="text-right">
        <b-button
          variant="outline-primary"
          @click="loadPreviousInvoices(2)"
        >
          {{ $t("documents-older-invoices") }} ›
        </b-button>
      </p>
    </div> -->
    <vita-other-documents></vita-other-documents>
    <vita-unsigned-docs></vita-unsigned-docs>
  </app-layout>
</template>

<script>
import AppLayout from "../../layouts/AppLayout.vue";
import SectionTitle from "../SectionTitle.vue";
import VitaMesFactures from "./Factures/Factures.vue";
import VitaOtherDocuments from "./Other/Other.vue";
import VitaLivretAccueil from "./Livret/Livret.vue";
import VitaTelegestion from "./Telegestion/Telegestion.vue";
import VitaUnsignedDocs from "./Unsigned/Unsigned.vue";
import VitaProjectService from "./ProjectService/ProjectService.vue";

var moment = require("moment");
export default {
  components: {
    AppLayout,
    SectionTitle,
    VitaMesFactures,
    VitaOtherDocuments,
    VitaLivretAccueil,
    VitaTelegestion,
    VitaUnsignedDocs,
    VitaProjectService
  },
  data() {
    return {
      moment: moment,
      invoicesFilterType: -1,
      allLoadedInvoices: {
        data: [1, 2],
        loaded: false
      },
      loadedUnpaidInvoices: {
        data: [1, 2],
        loaded: false
      },
      loadedPaidInvoices: {
        data: [1, 2],
        loaded: false
      },
      isNoMoreInvoices: false,
      unpaidInvoiceSize: 1,
      paidInvoiceSize: 1
    };
  },
  created() {},
  methods: {
    loadPreviousInvoices(filter) {
      this.$refs.invoices.loading = true;
      this.$refs.invoices.loadInvoices(filter);
    },
    onScrollTo(id) {
      const el = document.getElementById(id);
      if (el) {
        // Get the navbar height to offset the scroll position
        const navbar = document.querySelector(".b-navbar");
        const navbarHeight = navbar ? navbar.offsetHeight : 0;

        // Get element's position relative to the viewport
        const elementPosition = el.getBoundingClientRect().top;
        // Get the current scroll position
        const offsetPosition =
          elementPosition + window.pageYOffset - navbarHeight - 65; // 20px extra padding

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }
  }
};
</script>

<style lang="scss">
.facture-container {
  width: 525px;
}
</style>
